import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useDrawingArea } from '@mui/x-charts-pro';

type IncDonutChartLabelProps = {
  children: ReactNode;
  /** Optional secondary line rendered beneath the main value (e.g. a label). */
  sublabel?: string;
};

const IncDonutChartLabel = ({
  children,
  sublabel,
}: IncDonutChartLabelProps) => {
  const { width, height, left, top } = useDrawingArea();
  const cx = left + width / 2;
  const cy = top + height / 2;

  return (
    <>
      <Typography
        component="text"
        x={cx}
        // Nudge the value up when a sublabel sits below it.
        y={sublabel ? cy - 8 : cy}
        sx={theme => ({
          fill: theme.palette.text.primary,
          textAnchor: 'middle',
          dominantBaseline: 'central',
          fontSize: 24,
          fontWeight: 'bold',
        })}
      >
        {children}
      </Typography>
      {sublabel != null && (
        <Typography
          component="text"
          x={cx}
          y={cy + 18}
          sx={theme => ({
            fill: theme.palette.text.secondary,
            textAnchor: 'middle',
            dominantBaseline: 'central',
            fontSize: 13,
          })}
        >
          {sublabel}
        </Typography>
      )}
    </>
  );
};

export default IncDonutChartLabel;
